import { useEffect, useState } from "react";
import { QRCodeSVG } from 'qrcode.react';
import ScreenService from "./services/ScreenService";
import BackButton from './assets/backButton.svg'
import GearButton from './assets/gearButton.svg'
import "./ActivationScreen.scss";

const XumoActivationLanding = ({ setStep, handleKeyDown }) => (
    <div className="activation">
        <div className="sales-screen-container">
            <div className="sales-container">
                <div className="activation-cta-container">
                    {/* Title and subtitle */}
                    <div className="activation-cta-copy">
                        <div className="copy-titles">
                            <div className="copy-title">Ready to start watching your</div>
                            <div className="copy-title">purchased packages?</div>
                        </div>
                        <div className="copy-subtitles">
                            <div className="qr-activation-subtitle">NFL Sunday Ticket, Peacock Sports Pass</div>
                            <div className="qr-activation-subtitle">& more EverPass content</div>
                        </div>
                        <div className="pre-button-copy"> Activate your subscription to unlock your EverPass streaming access</div>
                    </div>
                    <button tabIndex={-1} autoFocus onKeyDown={()=> handleKeyDown(2)} onClick={() => setStep(2)} className="activate-button">
                        Activate Now
                    </button>

                    <div className="activation-cta-footer">
                        <div>If you need support to activate your device</div>
                        <div>
                            direct to <span className="span-semi-bold">{process.env.REACT_APP_XUMO_INFO_SHORTEN_LINK}</span>
                        </div>
                        <div>
                            or call <span className="span-semi-bold">{process.env.REACT_APP_SPECTRUM_HELP_DESK_NUMBER}</span>
                        </div>
                    </div>
                </div>
                <div className="separator"></div>
                <div className="sales-info-container">
                    <div className="sales-card">
                        <div className="sales-card-title">Don't have EverPass?</div>

                        <div className="sales-card-content">
                            <div>Get access to exclusive games and top</div>
                            <div>sports content like NFL Sunday Ticket,</div>
                            <div>Peacock Sports Pass and more!</div>
                        </div>

                        <div className="horizontal-separator"></div>

                        <div className="sales-card-footer">
                            <div>
                                <div>Call Spectrum Business now at</div>
                                <div>
                                    <span className="span-underlined">{process.env.REACT_APP_SPECTRUM_SALES_NUMBER}</span> to get started
                                </div>
                            </div>
                            <img className="spectrum-logo" src="https://cdn.upshow.tv/ui-assets/Spectrum_Logo.svg" alt="Spectrum logo" />
                        </div>
                    </div>
                </div>
            </div>
            <img 
                width={300}
                className="everpass-logo"
                src="https://cdn.upshow.tv/ui-assets/EverPass_Horizontal_All_White.png"
                alt="EverPass logo"
            />
        </div>
    </div>
);

const NewActivationScreen = ({ code, model, setStep, handleKeyDown }) => {
    const qrLink = process.env.REACT_APP_REMOTE_CONTROL + "pair/" + code;

    return (
        <div className="activation">
            {model.toLowerCase() === 'xumo' && (
                <button tabIndex={-1} autoFocus onKeyDown={()=> handleKeyDown(2)} onClick={() => setStep(1)} className="back-button">
                    <img src={BackButton}/>
                </button>
            )}
            <div className="instructions">
                <div className="instruction-title">Activate your subscription</div>
            </div>
            <div className="possible-activations">
                <div className="qr-activation-container">
                    <div className="qr-activation-title">Pair device using a phone or tablet</div>
                    <div className="qr-activation-subtitle-section">
                        <div className={ScreenService.isVertical ? "qr-activation-subtitle-vertical" : "qr-activation-subtitle"}>Scan this QR code from your phone or tablet and login to start streaming content.</div>
                    </div>
                    <QRCodeSVG size={2000} value={qrLink} level="H" includeMargin={true} style={{ borderRadius: "2rem", height: "300px", width: "300px" }} />
                </div>
                <div className="separator"></div>
                <div className="activation-code-container">
                    <div className="code-title">Pair device using a computer</div>
                    <div className="code-subtitle-section">
                        <div className={ScreenService.isVertical ? "code-subtitle-vertical" : "code-subtitle"}>
                            Go to <b>{process.env.REACT_APP_COMPUTER_PAIRING_MANAGER_LINK}</b> on your computer to link this device and start streaming.
                        </div>
                    </div>
                    <div className="code-content-container">
                        <div className={ScreenService.isVertical ? `code-title-contrast-vertical` : "code-title-contrast"}>Activation Code</div>
                        <div className={`${ScreenService.isVertical ? "vertical-code" : "code"} activation-code-content`}>{code}</div>
                    </div>
                </div>
            </div>
            <div className="contact">
                {model.toLowerCase() === 'xumo' ?<div className="contact-info-text">
                    <div>If you need support to activate your device</div>
                    <div>
                        please direct to <b>{process.env.REACT_APP_XUMO_INFO_SHORTEN_LINK}</b>
                    </div>
                    <div>
                        or call <b>{process.env.REACT_APP_SPECTRUM_HELP_DESK_NUMBER}</b>
                    </div>
                </div>
                :<div className="contact-info-text">
                    <div>If you need support to activate your device</div>
                    <div>please reach out to <b>support@everpass.com</b></div>
                    <div>or call <b>855-787-7469</b></div>
                </div>
                }
                <img className="everpass-logo" src="https://cdn.upshow.tv/ui-assets/EverPass_Horizontal_All_White.png" alt="EverPass logo" />
                {model.toLowerCase() === 'xumo' && (
                    <div className={`${ScreenService.isVertical ? "spectrum-sales-positioning-vertical" : "spectrum-sales-positioning"} spectrum-sales-container`}>
                        <div className={`${ScreenService.isVertical ? "spectrum-text-vertical" : "spectrum-text-horizontal"} spectrum-sales-text`}>
                            <div className="spectrum-sales-text-content">Interested in purchasing EverPass?</div>
                            <div className="spectrum-sales-text-content"> Call Spectrum Business now</div>
                            <div className="spectrum-sales-text-content">
                                at <span className="spectrum-phone">{process.env.REACT_APP_SPECTRUM_SALES_NUMBER}</span>{" "}
                            </div>
                        </div>
                        <img className="spectrum-logo" src="https://cdn.upshow.tv/ui-assets/Spectrum_Logo.svg" alt="Spectrum logo" />
                    </div>
                )}
            </div>
            {/* Check button, only shown for skykit */}
            <button id="checks-button" className="hidden">
                <img src={GearButton} />
            </button>
        </div>
    );
};

const ActivationSteps = ({ code, model}) => {
    const lastStepRecorded = model.toLowerCase() === "xumo" ? JSON.parse(localStorage.getItem('last-activation-step') ?? '1') : 2;
    const [step, setStep] = useState(lastStepRecorded);

    const setStepPersistent = (v) => {
        setStep(v);
        localStorage.setItem('last-activation-step', v);
    };

    const handleKeyDown = (event, step) => {
        const { key }  = event; 

        if (key === 'Enter') {
            setStepPersistent(step);
        }
    }

    // Sync local-storage on init 
    useEffect(()=> {
        setStepPersistent(lastStepRecorded);
    }, []);

    if (step === 1) {
        return (<XumoActivationLanding setStep={setStepPersistent} handleKeyDown={handleKeyDown} />);
    }
    if (step === 2) {
        return (<NewActivationScreen code={code} model={model} setStep={setStepPersistent} handleKeyDown={handleKeyDown}/>);
    }
    return <></>;
}

export default ActivationSteps;
